<template>
  <div class="pageBox">
	<Header current='souye' ref="Header"></Header>
	<div style="height:56px;"></div>
	<div class="cener">
		<div class="cener_one">
			<img src="@/assets/content/sqcg.png" />
		</div>
		<div class="cener_two">
			{{$t('i18n_370')}}
		</div>
		<div class="cener_three">
			{{$t('i18n_371')}}
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
  export default {
    components: {
		Header,
		Footer
    },
    data() {
      return {

      }
    },
    mounted() {
		this.$refs.Header.headerHover=true;
		this.$refs.Header.headerTrue=true;
		let locale = this.$i18n.locale;
		if(locale!='zh'){
			this.$router.push('/')
		}
    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.pageBox{
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	.cener{
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-height: 500px;
		.cener_one{
			margin-bottom: 9px;
			overflow: hidden;
			text-indent: -85px;
			width: 100px;
			height: 100px;
			margin-left: 30px;
			img{
				width: 100px;
				height: 100px;
				// mix-blend-mode:#64db40 ;
				 filter: drop-shadow(70px 0 0 #64db40) 
			}
		}
		.cener_two{
			margin-bottom: 17px;
			font-size: 29px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #B2B2B2;
		}
		.cener_three{
			font-size: 23px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #B2B2B2;
		}
	}
}
</style>
